import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { api } from 'constants/api';
import { ApiError, ApiResponse } from 'types/utils/api-response';
import { MutationOptions } from 'types/utils/mutation-options';

export type RefreshStoresResponseType = never;

export const useRefreshStores = (
  options?: MutationOptions<
    RefreshStoresResponseType,
    void,
    AxiosError<ApiError>
  >
) =>
  useMutation({
    mutationFn: async () => {
      const { data } = await api.post<ApiResponse<RefreshStoresResponseType>>(
        `/store/refresh`,
        {}
      );

      return data.data;
    },

    ...options,
  });
